import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/financeiro/contaspagar/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findContasPagar({
  empresa_cnpj,
  include,
  id,
  where = {},
  wherein = {},
  orWhereHas = {},
  page,
  perPage = "50",
  whereDoesntHave = {},
  fields,
  orWhere,
}) {
  let queryOrWhere = "";
  if (orWhere) {
    Object.keys(orWhere).forEach((key) => {
      queryOrWhere += `&orwhere[${key}]=${orWhere[key]}`;
    });
  }

  let queryHas = "";
  if (orWhereHas) {
    Object.keys(orWhereHas).forEach((key) => {
      queryHas += `&orwherehas[${key}]=${orWhereHas[key]}`;
    });
  }

  let query = "";
  Object.keys(where).forEach((value) => {
    query += `&where[${value}]=${where[value]}`;
  });

  let queryWhereIn = "";
  Object.keys(wherein).forEach((row) => {
    queryWhereIn += `&wherein[${row}]=${wherein[row]}`;
  });

  let queryWhereDoesntHave = "";
  Object.keys(whereDoesntHave).forEach((relation) => {
    queryWhereDoesntHave += `&whereDoesntHave[${relation}]=${JSON.stringify(
      whereDoesntHave[relation]
    )}`;
  });

  return search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}${
      include ? `&include=${include}` : ""
    }${query ?? ""}${queryOrWhere}${queryHas}${queryWhereIn ?? ""}${
      queryWhereDoesntHave ?? ""
    }${page ? `&page=${page}` : ""}${perPage ? `&per_page=${perPage}` : ""}${
      fields ? `&${fields}` : ""
    }`,
    "GET",
    headers
  );
}

export async function createContaPagar({ empresa_cnpj, body }) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}
